<template>
    <div>
        <div v-if="fetching" class="d-flex align-center">
            <div>Cargando...</div>
        </div>
        <template v-else>
            <v-card
                outlined
                class="pa-1" 
                v-for="(reporte, index) in computedList"
                :key="`summary-divisa-${index}-${reporte.divisa_id}`"
                :class="{'mt-1': index > 0}"
                >
                <template v-if="computedList.length > 1">
                    <div class="pa-1 text-overline line-height-1">{{ reporte.divisa }}</div>
                </template>
                <div class="d-flex flex-wrap">
                    <v-card elevation="0" class="flex-grow-1 pa-2 mr-2" outlined>
                        <div class="text-overline line-height-1" >TICKETS</div>
                        <div class="text-button font-weight-bold line-height-1">{{ reporte.count }}</div>
                        <div v-if="reporte.comparison?.count">
                            <template v-if="reporte.comparison.count[1] > 0">
                                <div class="text-caption accent--text line-height-1 d-flex align-center">
                                    <div>{{ reporte.comparison.count[1] }} ~ {{ reporte.comparison.count[0] | percent }}</div>
                                    <v-icon color="accent" x-small>mdi-trending-up</v-icon>
                                </div>
                            </template>
                            <template v-else>
                                <div class="text-caption error--text line-height-1 d-flex align-center">
                                    <div>{{ reporte.comparison.count[1] }} ~ {{ reporte.comparison.count[0] | percent }}</div>
                                    <v-icon color="error" x-small>mdi-trending-down</v-icon>
                                </div>
                            </template>
                        </div>
                    </v-card>
    
                    <v-card elevation="0" class="flex-grow-1 pa-2 mr-2" outlined>
                        <div class="text-overline line-height-1" >VENTA</div>
                        <div class="text-button font-weight-bold line-height-1">{{ reporte.venta | currency(reporte.divisa_code) }}</div>
                        <div v-if="reporte.comparison?.venta">
                            <template v-if="reporte.comparison.venta[1] > 0">
                                <div class="text-caption accent--text line-height-1 d-flex align-center">
                                    <div>{{ reporte.comparison.venta[1] | currency(reporte.divisa_code) }} ~ {{ reporte.comparison.venta[0] | percent }}</div>
                                    <v-icon color="accent" x-small>mdi-trending-up</v-icon>
                                </div>
                            </template>
                            <template v-else>
                                <div class="text-caption error--text line-height-1 d-flex align-center">
                                    <div>{{ reporte.comparison.venta[1] | currency(reporte.divisa_code) }} ~ {{ reporte.comparison.venta[0] | percent }}</div>
                                    <v-icon color="error" x-small>mdi-trending-down</v-icon>
                                </div>
                            </template>
                        </div>
                    </v-card>
    
                    <v-card elevation="0" class="flex-grow-1 pa-2 mr-2" outlined>
                        <div class="text-overline line-height-1">COMISIÓN</div>
                        <div class="text-button font-weight-bold line-height-1">{{ reporte.comision | currency(reporte.divisa_code) }} ~ {{ reporte.percent_comision | percent }}</div>
                        <div v-if="(reporte.comparison?.venta && reporte.comparison?.comision) && (reporte.comparison.venta[0] != reporte.comparison.comision[0])">
                            <div class="text-caption  line-height-1 d-flex align-center" :class="{
                                'error--text': reporte.comparison.comision[0] > reporte.comparison.venta[0],
                                'accent--text': reporte.comparison.comision[0] < reporte.comparison.venta[0],
                            }">
                                <div>{{ reporte.comparison.comision[1] | currency(reporte.divisa_code) }} ~ {{ reporte.comparison.comision[0] | percent }}</div>
                                <v-icon :color="reporte.comparison.comision[0] > reporte.comparison.venta[0] ? 'error' : 'accent'" x-small>
                                    <template v-if="reporte.comparison.comision[1] > 0">mdi-trending-up</template>
                                    <template v-else>mdi-trending-down</template>
                                </v-icon>
                            </div>
                        </div>
                    </v-card>
    
                    <v-card elevation="0" class="flex-grow-1 pa-2 mr-2" outlined>
                        <div class="text-overline line-height-1">PREMIO</div>
                        <div class="text-button font-weight-bold line-height-1">{{ reporte.premio | currency(reporte.divisa_code) }} ~ {{ reporte.percent | percent }}</div>
                        <div v-if="reporte.comparison?.premio">
                            <template v-if="reporte.comparison.premio[1] > 0">
                                <div class="text-caption error--text line-height-1 d-flex align-center">
                                    <div>{{ reporte.comparison.premio[1] | currency(reporte.divisa_code) }} ~ {{ reporte.comparison.premio[0] | percent }}</div>
                                    <v-icon color="error" x-small>mdi-trending-up</v-icon>
                                </div>
                            </template>
                            <template v-else>
                                <div class="text-caption accent--text line-height-1 d-flex align-center">
                                    <div>{{ reporte.comparison.premio[1] | currency(reporte.divisa_code) }} ~ {{ reporte.comparison.premio[0] | percent }}</div>
                                    <v-icon color="accent" x-small>mdi-trending-down</v-icon>
                                </div>
                            </template>
                        </div>
                    </v-card>
    
                    <v-card elevation="0" class="flex-grow-1 pa-2" outlined :class="{'mr-2': showBanqueo}">
                        <div class="text-overline line-height-1">TOTAL</div>
                        <div 
                            class="text-button font-weight-bold line-height-1"
                            :class="{ 'error--text': reporte.banqueo[0][1] < 0 }"
                            >
                            {{ reporte.total | currency(reporte.divisa_code) }}
                        </div>
                        <div v-if="reporte.comparison?.total">
                            <template v-if="reporte.comparison.total[1] > 0">
                                <div class="text-caption accent--text line-height-1 d-flex align-center">
                                    <div>{{ reporte.comparison.total[1] | currency(reporte.divisa_code) }} ~ {{ reporte.comparison.total[0] | percent }}</div>
                                    <v-icon color="accent" x-small>mdi-trending-up</v-icon>
                                </div>
                            </template>
                            <template v-else>
                                <div class="text-caption error--text line-height-1 d-flex align-center">
                                    <div>{{ reporte.comparison.total[1] | currency(reporte.divisa_code) }} ~ {{ reporte.comparison.total[0] | percent }}</div>
                                    <v-icon color="error" x-small>mdi-trending-down</v-icon>
                                </div>
                            </template>
                        </div>
                    </v-card>
    
                    <v-card elevation="0" class="flex-grow-1 pa-2 text-center" outlined v-if="showBanqueo">
                        <div class="text-overline line-height-1">BANQUEO</div>
                        <div class="font-weight-bold d-flex text-center line-height-1 text-caption">
                            <v-card outlined class="mr-1 pa-1" :class="{ 'accent--text': reporte.banqueo[0][1] >= 0, 'error--text': reporte.banqueo[0][1] < 0} ">
                                {{ reporte.banqueo[0][1] | currency(reporte.divisa_code) }} <br/> {{ reporte.banqueo[0][0] | percent }}
                            </v-card>
                            <v-card outlined class="pa-1">{{ reporte.banqueo[1][1] | currency(reporte.divisa_code) }} <br/> {{ reporte.banqueo[1][0] | percent }}</v-card> 
                        </div>
                    </v-card>
                </div>
            </v-card>
        </template>
    </div>
</template>

<script>
// TODO: Se sabe que se puede mejorar este monton de codigo repetido. MEJORAR

import ReportePorDivisaService from '@/services/reporte/ventas/ReportePorDivisaService';

export default {
    components: {},
    props: {
        params: {
            defaults: function() {
                return {};
            },
        },
        context: {
            default: 'comercio',
        },
    },
    data: function() { 
        return {
            list: [],
            fetching: false,
        }
    },
    computed: {
        showBanqueo: function () {
            return this.list.some(reporte => reporte.banqueo[0][0]);
        },
        computedList: function () {
            return this.list.length ? this.list : [{
                count: 0,
                venta: 0,
                comision: 0,
                premio: 0,
                total: 0,
                banqueo: [[0, 0], [0, 0]],
                percent: 0,
            }];
        }
    },
    methods: {
        fetch: async function () {
            this.fetching = true;
            this.list = [];

            const params = { ... this.params };

            if (this.context == 'sistema') {
                params['group_by'] = 'sistema';
                params['comercio_type'] = 'sistema';
            }

            try {
                const {
                    reportList
                } = await ReportePorDivisaService.getConsolidado(params);

                this.list = reportList;
            } catch (error) {
                console.log(error);
            }

            this.fetching = false;
        }
    },
    watch: {
        params: function () {
            this.fetch();
        }
    },
}
</script>
<style>

</style>